// src/Pages/Reports.js
import React, { useState } from "react";
import { FaChartBar, FaUsers, FaHistory } from "react-icons/fa";
import FinancialReports from "./FinancialReports";
import UserReports from "./UserReports";
import ReportHistory from "./ReportHistory";
import CustomDropdown from "../../Components/CustomDropdown";

const Reports = () => {
  const [activeTab, setActiveTab] = useState("financial");
  const [period, setPeriod] = useState("24h"); // القيمة الافتراضية للفترة

  const renderContent = () => {
    switch (activeTab) {
      case "financial":
        return <FinancialReports period={period} />;
      case "users":
        return <UserReports period={period} />;
      case "history":
        return <ReportHistory period={period} />;
      default:
        return null;
    }
  };

  return (
    <div className="p-6 font-cairo bg-light min-h-screen">
      {/* 🔹 تابات + اختيار الفترة */}
      <div className="flex items-center justify-between mb-6 border-b border-gray-200">
        {/* التابات */}
        <div className="flex gap-4">
          <button
            onClick={() => setActiveTab("financial")}
            className={`flex items-center gap-2 px-4 py-2 font-semibold rounded-t-lg transition ${activeTab === "financial"
              ? "text-main1 border-b-2 border-main1"
              : "text-gray-500 hover:text-main1"
              }`}
          >
            <FaChartBar /> التقارير المالية
          </button>

          <button
            onClick={() => setActiveTab("users")}
            className={`flex items-center gap-2 px-4 py-2 font-semibold rounded-t-lg transition ${activeTab === "users"
              ? "text-main1 border-b-2 border-main1"
              : "text-gray-500 hover:text-main1"
              }`}
          >
            <FaUsers /> تقارير المستخدمين
          </button>

          <button
            onClick={() => setActiveTab("history")}
            className={`flex items-center gap-2 px-4 py-2 font-semibold rounded-t-lg transition ${activeTab === "history"
              ? "text-main1 border-b-2 border-main1"
              : "text-gray-500 hover:text-main1"
              }`}
          >
            <FaHistory /> سجل التقارير
          </button>
        </div>

        {/* اختيار الفترة */}
        <div className="flex mb-1">
          <CustomDropdown
            options={[
              { value: "24h", label: "آخر 24 ساعة" },
              { value: "7d", label: "آخر 7 أيام" },
              { value: "30d", label: "آخر 30 يوم" },
              { value: "90d", label: "آخر 90 يوم" },
              { value: "1y", label: "آخر سنة" },
            ]}
            selectedValue={period}
            onChange={setPeriod}
          />
        </div>
      </div>

      {/* 🔹 محتوى التاب */}
      {renderContent()}
    </div>
  );
};

export default Reports;
